import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['attachmentInput', 'removeField', 'fileRow', 'dropZone']

  remove(event) {
    const { removeFieldId, attachmentId, uploaderKey } = event.currentTarget.dataset

    if (attachmentId) {
      const result = this.#removeAttachmentInputById(attachmentId)
      if (result.removed && !result.hasRemaining) this.#markForRemoval(removeFieldId)
    } else {
      this.#markForRemoval(removeFieldId)
    }

    this.#hideFileRow({ attachmentId, uploaderKey, button: event.currentTarget })
    this.element.dispatchEvent(new CustomEvent('form-file-attachment-remover:removed', { bubbles: true }))
  }

  #removeAttachmentInputById(attachmentId) {
    const blobInput = this.attachmentInputTargets.find(input => input.dataset.attachmentId === attachmentId)
    if (!blobInput) return { removed: false, hasRemaining: false }

    const { name, value } = blobInput
    blobInput.remove()
    this.#removeMatchingSignedIdInputs(name, value)

    return {
      removed: true,
      hasRemaining: this.#hasRemainingAttachmentInputs(name)
    }
  }

  #removeMatchingSignedIdInputs(name, value) {
    this.element.querySelectorAll(`input[type="hidden"][name="${name}"]`).forEach(input => {
      if (input.value === value) input.remove()
    })
  }

  #hasRemainingAttachmentInputs(name) {
    return Array.from(this.element.querySelectorAll(`input[type="hidden"][name="${name}"]`)).some(input => input.value)
  }

  #markForRemoval(removeFieldId) {
    const field = this.removeFieldTargets.find(el => el.id === removeFieldId)
    if (!field) return

    field.type === 'checkbox' ? (field.checked = true) : (field.value = 'true')
  }

  #hideFileRow({ attachmentId, uploaderKey, button }) {
    const fileRow = this.#findFileRow(attachmentId, button)
    if (!fileRow) return

    fileRow.classList.add('is-hidden')

    const dropZone = this.#findDropZone(uploaderKey)
    if (dropZone) {
      dropZone.hidden = false
      dropZone.querySelector('c12-uploader')?.reset()
    }
  }

  #findFileRow(attachmentId, button) {
    if (attachmentId) {
      const targetRow = this.fileRowTargets.find(row => row.dataset.attachmentId === attachmentId)
      if (targetRow) return targetRow
    }

    return button.closest('.file-row')
  }

  #findDropZone(uploaderKey) {
    if (!uploaderKey) return null

    return this.dropZoneTargets.find(dropZone => dropZone.dataset.uploaderKey === uploaderKey) || null
  }
}
